// btw-front/src/components/Popup/ReponsivePopup.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";

const STORAGE_KEY = "btw_home_notice_dismissed_v1";

export default function ResponsivePopup() {
  const [open, setOpen] = useState(false);

  const shouldOpen = useMemo(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) !== "1";
    } catch {
      return true;
    }
  }, []);

  useEffect(() => {
    if (shouldOpen) {
      const t = setTimeout(() => setOpen(true), 900);
      return () => clearTimeout(t);
    }
  }, [shouldOpen]);

  const close = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {}
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={close}
      center
      closeOnOverlayClick
      styles={{
        modal: {
          borderRadius: 16,
          maxWidth: 520,
          width: "calc(100% - 24px)",
        },
      }}
    >
      <div style={{ padding: 4 }}>
        <div style={{ fontWeight: 700, fontSize: 18, color: "#0f172a" }}>빠른 문의 안내</div>
        <div style={{ marginTop: 10, fontSize: 14, lineHeight: 1.6, color: "#475569" }}>
          “프로젝트 문의”를 누르고 요구사항을 적어주시면 메일 작성 창이 바로 열립니다. (팝업은 1회만
          표시됩니다.)
        </div>

        <div style={{ marginTop: 16, display: "flex", gap: 10 }}>
          <a
            href="#contact"
            onClick={close}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px 16px",
              borderRadius: 999,
              background: "#000",
              color: "#fff",
              fontSize: 14,
              fontWeight: 600,
            }}
          >
            문의하기
          </a>
          <button
            onClick={close}
            style={{
              padding: "10px 16px",
              borderRadius: 999,
              border: "1px solid #e2e8f0",
              background: "#fff",
              color: "#0f172a",
              fontSize: 14,
              fontWeight: 600,
            }}
          >
            닫기
          </button>
        </div>
      </div>
    </Modal>
  );
}
